export default "__VITE_ASSET__Cnshi3b4__"